const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || "http://localhost:8000";
import { getSessionHeaders } from "@/components/utils";
import { LoginRequest, LoginResponse } from "@/common/interface/auth";

export interface SignupRequest {
  schoolCode: string;
  name: string;
  title: string;
  phone: string;
  password: string;
  confirmPassword: string;
  agreeToTerms: boolean;
  agreeToPrivacy: boolean;
}

export interface SignupResponse {
  success: boolean;
  message: string;
}

export async function loginUser(
  credentials: LoginRequest
): Promise<LoginResponse> {
  const response = await fetch(`${API_BASE_URL}/auth/login`, {
    method: "POST",
    headers: getSessionHeaders(),
    credentials: "include",
    body: JSON.stringify(credentials),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "로그인에 실패했습니다.");
  }

  return response.json();
}

export async function signupUser(
  signupData: SignupRequest
): Promise<SignupResponse> {
  const response = await fetch(`${API_BASE_URL}/auth/signup`, {
    method: "POST",
    headers: getSessionHeaders(),
    credentials: "include",
    body: JSON.stringify(signupData),
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.message || "회원가입에 실패했습니다.");
  }

  return result;
}

export async function logoutUser(): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/auth/logout`, {
    method: "GET",
    credentials: "include",
    headers: getSessionHeaders(),
  });

  if (!response.ok) {
    throw new Error("로그아웃에 실패했습니다.");
  }
}

export async function checkAuth(): Promise<boolean> {
  return (await getUserInfo()).isAuthenticated;
}

export async function getUserInfo(): Promise<LoginResponse> {
  try {
    const response = await fetch(`${API_BASE_URL}/auth`, {
      method: "GET",
      credentials: "include",
      headers: getSessionHeaders(),
    });

    if (!response.ok) {
      return {
        isAuthenticated: false,
        user: {
          schoolCode: "",
          schoolName: "",
          teacherCode: 0,
          name: "",
          role: "",
          auth: [],
          options: []
        },
      };
    }

    return response.json();
  } catch {
    return {
      isAuthenticated: false,
      user: {
        schoolCode: "",
        schoolName: "",
        teacherCode: 0,
        name: "",
        role: "",
        auth: [],
          options: []
      },
    };
  }
}

export async function getIP(): Promise<string> {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/ip`, {
      method: "GET",
      credentials: "include",
      headers: getSessionHeaders(),
    });

    if (!response.ok) {
      return "IP 조회 실패";
    }

    const data = await response.json();
    return data.ip;
  } catch {
    return "IP 조회 실패";
  }
}
